import React from 'react';
import { FC } from 'react';
import { Field } from 'redux-form';
import { Text } from 'components/text/Text';
import { HeadingPublishOffer } from './common';
import {
  FormInputCheckBoxSelect,
  FormInputCheckBoxSelectProps,
} from 'components/form-inputs/form-input-check-box-select/form-input-check-box-select';
import styled from 'styled-components';
import { SelectOption } from 'components/form-inputs/select-option/select-option';

interface CheckBoxSelectInputProps {
  fieldName: string;
  heading: string;
  paragraph: string;
  options: SelectOption[];
}

export const CheckBoxSelectInput: FC<CheckBoxSelectInputProps> = ({
  fieldName,
  heading,
  paragraph,
  options,
}) => {
  return (
    <div>
      <HeadingPublishOffer level={2}>{heading}</HeadingPublishOffer>
      <Text size={14} color="grey">
        {paragraph}
      </Text>
      <Content>
        <Field<FormInputCheckBoxSelectProps>
          name={fieldName}
          component={FormInputCheckBoxSelect}
          options={options}
        />
      </Content>
    </div>
  );
};

const Content = styled.div`
  margin-bottom: 20px;
  margin-top: 20px;
`;
